let _ = (t)=>t, t;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { css } from '@emotion/react';
import { Element, Group, Text, tokens } from '@klarna/ui';
import RichTextMarkdown from 'features/richText/components/richTextMarkdown/RichTextMarkdown';
import { getSiteSetting } from 'framework/globalStorage/settingsStore';
import { useTranslate } from 'framework/utils/i18n/useTranslate';
import { memo } from 'react';
import WarningIcon from './components/WarningIcon';
const KovfsWarning = ({ paddingHorizontal })=>{
    var _getSiteSetting;
    const showKovfs = (_getSiteSetting = getSiteSetting('regulations')) === null || _getSiteSetting === void 0 ? void 0 : _getSiteSetting.kovfs;
    const translate = useTranslate();
    if (!showKovfs) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Group, {
        backgroundColor: "bg/plain",
        borderRadius: "radius/16",
        direction: "horizontal",
        gap: "space/16",
        paddingHorizontal: paddingHorizontal,
        paddingVertical: "space/16",
        children: [
            /*#__PURE__*/ _jsx(Element, {
                alignVertical: "center",
                shrink: 0,
                children: /*#__PURE__*/ _jsx(WarningIcon, {
                    size: 40
                })
            }),
            /*#__PURE__*/ _jsxs(Element, {
                grow: true,
                shrink: true,
                direction: "vertical",
                gap: "space/4",
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        fontWeight: "bold",
                        textToken: "body/s",
                        children: translate('Installment.Regulations.KOVFS_WARNING_HEADING')
                    }),
                    /*#__PURE__*/ _jsx(RichTextMarkdown, {
                        sx: css(t || (t = _`
            max-width: 100%;

            p,
            p > *,
            a {
              font-size: ${0}px;
              line-height: ${0}px;
              color: ${0};
            }
            a:hover {
              color: ${0};
            }
          `), tokens.textSizes['text/desktop/xs'], tokens.lineHeights['body/desktop/xs'], tokens.colors.light['text/subtle'], tokens.colors.light['text/subtle']),
                        children: translate('Installment.Regulations.KOVFS_WARNING_BODY')
                    })
                ]
            })
        ]
    });
};
export default /*#__PURE__*/ memo(KovfsWarning);
